import React, {Component} from "react";
import {Checkbox, Col, Input, Row, Tabs} from 'antd';
import './zykList.css';
import PictureList from "./zyk/picture_list";
import AudioList from "./zyk/audio_list";
import VideoList from "./zyk/video_list";
import FileList from "./zyk/file_list";
import {connect} from "react-redux";
import {changZykSearchText} from "../actions";
import ContentImgList from "./zyk/contentImg_list.js";
import ListComponent from "./zyk/list_componet";
import $ from 'jquery'

/**
 * 资源信息列表
 */


class ZykTabList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count: 0,
        }
    };


    onChange(e) {
        //重新获取搜索框的值；
        let searchInput=$('.zykListContainer input')[0];
        let onlyMe = e.target.checked;
        let searchKey=$(searchInput).val();
        let tableKey=this.props.tableKey;
        let doSearch=(new Date()).getTime();
        this.props.changZykSearchText(searchKey, onlyMe, tableKey,doSearch)

    }

    componentWillUnmount() {
        let doSearch=(new Date()).getTime();
        this.props.changZykSearchText("", false, 1,doSearch)
    }

    searchData(value) {
        let onlyMe=this.props.onlyMe;
        let tableKey=this.props.tableKey;
        let doSearch=(new Date()).getTime();
        this.props.changZykSearchText(value, onlyMe, tableKey,doSearch)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let tabId =nextProps.tableKey;
        let allCount = 0;
        switch (tabId) {
            case 1:
                allCount=nextProps.zykStoryCount
                    break;
            case 2:
                allCount=nextProps.zykPictureCount
                break;
            case 3:
                allCount=nextProps.zykAudioCount
                break;
            case 4:
                allCount=nextProps.zykVideoCount
                break;
            case 5:
                allCount=nextProps.zykDocumentCount
                break;
            case 6:
                allCount=nextProps.contentPictureCount
                break;
            default:
                allCount=0
                break;
        }
        this.setState({
            count:allCount
        })

    }

    componentDidMount() {
        let allCount=this.props.zykStoryCount
        this.setState({
            count:allCount
        })
    }

    callback(key) {
        let searchInput=$('.zykListContainer input')[0];
        let onlyMe=this.props.onlyMe;
        let searchText=$(searchInput).val();
        let doSearch=(new Date()).getTime();
        let intKey=parseInt(key);
        this.props.changZykSearchText(searchText, onlyMe, intKey,doSearch)
    }

    render() {
        const {Search} = Input;
        const {TabPane} = Tabs;

        //pms需要加入稿件内容图片页签；
        const contentImgeTab = (<TabPane tab="稿件内容图片" key="6" className='tabContent'>
            <ContentImgList/>
        </TabPane>);

        return <div className='zykListContainer'>
            <div>
                <h1 style={{fontSize:'15px'}}>资源信息</h1>
                <Search id={"searchButton"}
                    placeholder="搜索..."
                    enterButton="查询"
                    size="large"
                    onSearch={value => this.searchData(value)}
                />
                <Row className='allRecord'>
                    <Col span={12}>
                        <Checkbox onChange={(e) => this.onChange(e)}> 仅我的资源</Checkbox>
                    </Col>
                    <Col span={12}>
                        <p id="allCount" style={{textAlign: 'right'}}>共{this.state.count}条记录</p>
                    </Col>
                </Row>

            </div>
            <div className="zykTables">
                <Tabs defaultActiveKey="1" onChange={(e)=>{this.callback(e)}}>
                    <TabPane  tab="稿件库" key="1" className='tabContent'>
                        <ListComponent/>
                    </TabPane>
                    <TabPane tab="图片库" key="2" className='tabContent'>
                        <PictureList/>
                    </TabPane>
                    <TabPane tab="音频库" key="3" className='tabContent'>
                        <AudioList/>
                    </TabPane>
                    <TabPane tab="视频库" key="4" className='tabContent'>
                        <VideoList/>
                    </TabPane>
                    <TabPane tab="文件库" key="5" className='tabContent'>
                        <FileList/>
                    </TabPane>
                    {contentImgeTab}
                </Tabs>
            </div>
        </div>
    }
}


function mapStateToProps(state) {
    return {
        searchText: state.zykReducer.searchText,
        onlyMe: state.zykReducer.onlyMe,
        tableKey: state.zykReducer.tableKey,
        doSearch:state.zykReducer.doSearch,
        zykStoryCount: state.zykReducer.zykStoryCount,
        zykPictureCount: state.zykReducer.zykPictureCount,
        zykAudioCount: state.zykReducer.zykAudioCount,
        zykVideoCount: state.zykReducer.zykVideoCount,
        zykDocumentCount: state.zykReducer.zykDocumentCount,
        contentPictureCount: state.zykReducer.contentPictureCount,
    }
}


function mapStateToMethod(dispatch) {
    return {
        changZykSearchText: function (searchText, onlyMe,tableKey,doSearch) {
            return dispatch(changZykSearchText(searchText, onlyMe, tableKey,doSearch));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(ZykTabList);
